import {
  UPDATE_PROPS,
  GO_TO_ADD_RISK_PRODUCT,
  SET_RISK_PRODUCT_TYPE_TO_CREATE,
  GO_TO_INDEX,
  BACK,
  DELETE_RISK_PRODUCT,
  UPDATE_RISK_PRODUCT,
  CONFIRM_DELETE,
  SUBMIT_FORM,
  LOADING
} from './actions'

import { formFieldsForRiskProductType } from './utils/formFieldsForRiskProductType'
import { R } from '@utils/currency'
import { humanizeString } from '@utils/stringMinipulation'
import {
  totalValue,
  totalMonthlyContributions
} from '@utils/riskProducts'

export const SCREEN_STATES = {
  INDEX: 'index',
  CREATE: 'create',
  FORM: 'form',
  DESTROY: 'destroy'
}

export default function reducer(state, { type, payload }) {
  switch (type) {
    case UPDATE_PROPS:
      return {
        ...state,
        riskProducts: payload.props.riskProducts,
        totalMonthlyContributions: R(totalMonthlyContributions(payload.props.riskProducts)).format(),
        totalValue: R(totalValue(payload.props.riskProducts)).format(),
      }
    case GO_TO_ADD_RISK_PRODUCT:
      return {
        ...state,
        cameFrom: state.screen,
        screen: SCREEN_STATES.CREATE,
        title: 'Choose the type of risk product you want to add'
      }
    case GO_TO_INDEX:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        title: 'Risk products you currently have'
      }
    case BACK:
      return {
        ...state,
        screen: state.cameFrom,
        cameFrom: state.cameFrom === SCREEN_STATES.FORM ? SCREEN_STATES.INDEX : state.screen
      }
    case SET_RISK_PRODUCT_TYPE_TO_CREATE:
      return {
        ...state,
        screen: SCREEN_STATES.FORM,
        cameFrom: state.screen,
        title: humanizeString(payload.riskProductType),
        riskProductIndex: null,
        riskProduct: {},
        formRiskProductType: payload.riskProductType,
        formFields: formFieldsForRiskProductType(),
        submitLabel: 'add risk product',
        deleteLabel: 'back to all risk products',
        backLabel: 'back'
      }
    case UPDATE_RISK_PRODUCT:
      return {
        ...state,
        screen: SCREEN_STATES.FORM,
        cameFrom: state.screen,
        riskProductIndex: payload.riskProductIndex,
        riskProductId: state.riskProducts[payload.riskProductIndex].id,
        riskProduct: { ...state.riskProducts[payload.riskProductIndex] },
        formRiskProductType: state.riskProducts[payload.riskProductIndex].risk_product_type,
        title: humanizeString(state.riskProducts[payload.riskProductIndex].risk_product_type),
        formFields: formFieldsForRiskProductType(),
        submitLabel: 'update risk product',
        deleteLabel: 'delete risk product',
        backLabel: 'back'
      }
    case DELETE_RISK_PRODUCT:
      return {
        ...state,
        screen: SCREEN_STATES.DESTROY,
        cameFrom: state.screen,
        riskProductIndex: payload.riskProductIndex,
        riskProduct: state.riskProducts[payload.riskProductIndex]
      }
    case SUBMIT_FORM:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false
      }
    case CONFIRM_DELETE:
      return {
        ...state,
        screen: SCREEN_STATES.INDEX,
        cameFrom: state.screen,
        loading: false
      }
    case LOADING:
      return {
        ...state,
        loading: true
      }
  }
}

export const propsToState = (props) => ({
  screen: SCREEN_STATES.INDEX,
  cameFrom: SCREEN_STATES.INDEX,
  title: 'Risk products you currently have',
  riskProducts: props.riskProducts,
  riskProduct: {},
  riskProductIndex: null,
  submitLabel: null,
  deletelLabel: null,
  backLabel: null,
  formFields: null,
  totalValue: R(totalValue(props.riskProducts)).format(),
  totalMonthlyContributions: R(totalMonthlyContributions(props.riskProducts)).format(),
})
